import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const TestIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Test",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.73 27.46c.17-.34.27-.74.27-1.17 0-.62-.21-1.19-.57-1.65s-8.04-9.72-8.04-9.72V6.27h.54a1.62 1.62 0 1 0 0-3.24H10.04a1.62 1.62 0 1 0 0 3.24h.54v8.65l-8.04 9.73a2.701 2.701 0 0 0 2.16 4.32h22.61c1.06 0 1.97-.61 2.41-1.5v-.02Zm-12.66-2.81c0-.6.48-1.08 1.08-1.08h5.41c.6 0 1.08.48 1.08 1.08s-.48 1.08-1.08 1.08h-5.41c-.6 0-1.08-.48-1.08-1.08m-3.61-8.16c.23-.28.37-.64.37-1.03V6.28h4.32v9.24c0 .39.14.75.37 1.03s3.17 3.78 3.17 3.78h-11.4z"
    })
  }));
};